import React, { useContext, useEffect, useState, useCallback } from 'react';

import {
  Grid,
  Button,
  Dialog,
  Typography,
  DialogTitle,
  DialogActions,
  DialogContent,
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

import RestoreIcon from '@material-ui/icons/Restore';

import Ranking from './Ranking';
import Comment from './Comment';
import Ignore from './Ignore';
import { ContextNotificacoes } from '../../services/notificacoes';
import {
  getSurveyQuestions,
  postSurveyQuestions,
  postSurveyComment,
} from '../../services/endPointsNotificacoes';

import {
  marcarNotificacaoPesquisaComoRespondida,
  marcarNotificacaoContratoFinanciamentoLida,
  marcarNotificacoesComoExibidas,
} from '../../services/marcarNotificacaoLida';

import { Spinner } from '../StyledComponent';

import { ContextGetData } from '../../services/getData';

import { ContextSolicitacoes } from '../../services/solicitacoes';
import { getSurvey } from '../../Utils/tiposPesquisaSatisfacao';

export default function SatisfactionSurvey({
  close,
  setNotificationsModal,
  home,
}) {
  const { idConta, imoveis } = useContext(ContextGetData);
  const { atualizaNotificacoes, setSurveyModal, surveyModal } =
    useContext(ContextNotificacoes);
  const { getTipoSolicitacoes, tiposSolicitacoes } =
    useContext(ContextSolicitacoes);

  const [isSubmiting, setIsSubmiting] = useState(false);
  const [isLoadingQuestions, setIsLoadingQuestions] = useState(true);
  const [questions, setQuestions] = useState([]);
  const [comment, setComment] = useState('');

  const useStyles = makeStyles({
    title: {
      color: '#0249d0',
      textAlign: 'left',
      background: '#ccdaf6',
      borderBottom: '2px solid',
    },
    subTitle: {
      fontWeight: 700,
      marginBottom: 12,
      padding: '8px 24px',
      background: '#F6F6F6',
    },
  });

  const classes = useStyles();

  const handleDeny = useCallback(() => {
    setTimeout(close, 0);
  }, []);

  const handleSubmit = useCallback(() => {
    (async function () {
      setIsSubmiting(true);

      const imovelId =
        surveyModal?.ImovelId ??
        imoveis.filter(
          (imovel) =>
            imovel.assetIdSalesFoce === surveyModal?.ImovelIdSalesforce
        )[0]?.id;

      const notificacaoSolicitacaoConcluidaId =
        surveyModal?.Grupo === 'SOLICITACAO' ? surveyModal?.Id : null;

      const notificacaoContratoFinanciamentoId =
        surveyModal?.Grupo === 'FINANCIAMENTO' ? surveyModal?.Id : null;

      const idSalesForce = surveyModal?.IdSalesForce;

      for (const question of questions) {
        await postSurveyQuestions(
          question,
          imovelId,
          notificacaoSolicitacaoConcluidaId,
          notificacaoContratoFinanciamentoId,
          idConta
        );
      }

      if (comment) {
        await postSurveyComment(
          imovelId,
          idConta,
          notificacaoSolicitacaoConcluidaId,
          notificacaoContratoFinanciamentoId,
          comment
        );
      }

      if (surveyModal?.Grupo === 'FINANCIAMENTO') {
        await marcarNotificacaoContratoFinanciamentoLida(surveyModal?.Id);
      } else {
        await marcarNotificacaoPesquisaComoRespondida(idSalesForce);
      }

      await atualizaNotificacoes();

      if (!home) setNotificationsModal(false);

      setSurveyModal(null);
      close();

      setTimeout(close, 0);

      setIsSubmiting(false);
    })();
  }, [questions, comment]);

  const anyQuestionEmpty = useCallback(() => {
    const questionsEmpty =
      questions &&
      questions.filter(
        (question) =>
          !question?.value && question.value !== 0 && !question?.ignored
      );

    return questionsEmpty?.length > 0;
  }, [questions]);

  useEffect(() => {
    const marcarExibidasAll = async (id) => {
      await marcarNotificacoesComoExibidas(id);
    };
    const getQuestions = async () => {
      setIsLoadingQuestions(true);
      let {
        Grupo,
        Subgrupo,
        TipoPesquisaSatisfacao,
        AssetId: assetId,
      } = surveyModal;

      if (
        TipoPesquisaSatisfacao === 'Relacionamento' &&
        Subgrupo !== 'ENTREGA_UNIDADE'
      ) {
        Subgrupo = '';
      }

      let questions = await getSurveyQuestions({ Grupo, Subgrupo, assetId });

      if (questions && questions?.length > 0) {
        questions = questions?.map((r) => {
          return { ...r, ignored: false };
        });

        setQuestions(questions);
      }
      setIsLoadingQuestions(false);
    };

    (async function () {
      if (surveyModal) {
        await getQuestions();
        await marcarExibidasAll({
          IdsSalesForceNotificacoesSolicitacaoConcluida:
            surveyModal?.IdSalesForce ? [surveyModal?.IdSalesForce] : [],
          IdsNotificacaoContratoFinanciamento:
            surveyModal?.DataAssinaturaContrato ? [surveyModal.Id] : [],
          IdsNotificacaoAtualizacaoFotos: [],
          IdsNotificacaoDestaques: [],
          IdsNotificacaoNoticias: [],
          IdsNotificacaoVideos: [],
          IdsNotificacaoAniversario: [],
          IdsSalesForceNotificacaoSolicitacaoFase: [],
          IdsSalesForceNotificacaoVistoriaNaoCompareceu: [],
          NotificacoesSolicitacaoAgendamento: [],
          NotificacoesFinanceiroBoletosPendentes: [],
          NotificacoesFinanceiroBoletosVencidos: [],
          NotificacoesFinanceiroParcelasPendentes: [],
          NotificacoesFinanceiroParcelasVencidas: [],
          IdsNotificacaoManutencaoPeriodica: [],
        });
      }
    })();
  }, []);

  useEffect(() => {
    (async function () {
      if (!tiposSolicitacoes?.length > 0) {
        await getTipoSolicitacoes();
      }
    })();
  }, []);

  const isOpenModal =
    (!isLoadingQuestions && surveyModal && questions?.length > 0) ?? false;
  console.log('questions', questions);
  return (
    <Dialog open={isOpenModal}>
      <DialogTitle className={classes.title}>
        <strong>Pesquisa de satisfação</strong>
      </DialogTitle>

      <Typography variant='body2' color='initial' className={classes.subTitle}>
        {getSurvey(surveyModal, tiposSolicitacoes)?.textoPesquisa}
      </Typography>

      <DialogContent>
        {questions &&
          questions?.map((question, index) => {
            return (
              <div key={question.Id}>
                <Typography
                  variant='body2'
                  color='initial'
                  style={{ marginBottom: 8 }}
                >
                  <strong>
                    {index + 1} - {question.Pergunta}
                  </strong>
                </Typography>

                <Ranking
                  questions={questions}
                  question={question}
                  setQuestions={setQuestions}
                  index={index}
                  disabled={question?.ignored}
                />

                {!question?.TemComentario && (
                  <Ignore
                    question={question}
                    questions={questions}
                    index={index}
                    setQuestions={setQuestions}
                  />
                )}

                {question?.TemComentario && (
                  <Comment
                    title={question?.TextoComentario}
                    question={question}
                    questions={questions}
                    value={question?.Comentario ?? ''}
                    setValue={(value) => {
                      const clonedQuestions = [...questions];
                      clonedQuestions[index].Comentario = value;
                      setQuestions([...clonedQuestions]);
                    }}
                  />
                )}
              </div>
            );
          })}

        <Comment
          title={`Deixe sua sugestão para que possamos melhorar
           sua experiência no futuro:`}
          value={comment}
          setValue={setComment}
        />
        <Typography variant='body2' color='initial' style={{ marginTop: -16 }}>
          <strong>A sua opinião é muito importante. </strong>
          Contamos com a sua colaboração!
        </Typography>
      </DialogContent>

      <DialogActions style={{ marginTop: 24 }}>
        <Grid container justify='space-between' alignItems='center'>
          <Button
            onClick={handleDeny}
            color='secondary'
            startIcon={<RestoreIcon />}
            style={{ textTransform: 'none' }}
            disabled={isSubmiting}
          >
            <strong>Não quero responder agora</strong>
          </Button>

          <Button
            color='primary'
            variant='contained'
            onClick={handleSubmit}
            disabled={anyQuestionEmpty() || isSubmiting}
          >
            {isSubmiting ? <Spinner /> : 'Enviar'}
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
